import React from "react";
import { Breakpoint } from "react-socks";
import CustomerZonePointsChart from "../components/CustomerZonePointsGraph";
import CustomerTimelineZone from "../components/CustomerTimelineZone";
import CustomerDashboardHeader from "../components/CustomerDashboardHeaderdata";
import CustomerZones from "../components/CustomerZones";

export default function Dashboard({ zones = [] }) {
  return (
    <div>
      <div className="col">
        <CustomerDashboardHeader />
      </div>
      
      {/* Tablet & Desktop View */}
      <Breakpoint medium up>
        <div className="col">
          <CustomerZonePointsChart />
        </div>
        <div className="col">
          <CustomerTimelineZone />
        </div>
      </Breakpoint>
      
      {/* Mobile View */}
      <Breakpoint small down>
        <div className="mobile-zones-list" style={{ padding: "20px" }}>
          {zones && zones.map((zone, index) => {
            // Calculate the percentage
            const percent = zone.targetPoints
              ? Math.min(zone.points / zone.targetPoints, 1)
              : 0;
            const displayPercent = Math.round(percent * 100);

            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  
                  // UI Changes: White frame with rounded corners
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",             // Rounded corners
                  padding: "12px 16px",            // Inside spacing
                  marginBottom: "10px",            // Space between each cards
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)", // Optional subtle shadow to pop out from background
                  border: "1px solid #e5e7eb"      // Clean light border line
                }}
              >
                {/* Left Side: Circle + Name */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <CustomerZones zones={[zone]} />
                  <span style={{ fontWeight: "500", fontSize: "14px", color: "#333" }}>
                    {zone.name || "Zone Name"}
                  </span>
                </div>

                {/* Right Side: Percentage */}
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#000000", // UI Changes: Percent turned flat black
                  }}
                >
                  {displayPercent}%
                </div>
              </div>
            );
          })}
        </div>
      </Breakpoint>
    </div>
  );
}